module.exports = __webpack_public_path__ + "static/NewBaskervilleStd-Roman-02c47da1edfb3eca55804cc5e6280aa6.woff";